import { useFormContext, Controller } from 'react-hook-form';
import { FormControl, FormHelperText } from '@mui/material';
import CasSimpleLexicalRichTextEditor from './CasSimpleLexicalRichTextEditor';

type Props = {
  name: string;
  label?: string;
  helperText?: string;
  placeholder?: string;
  mode?: 'full' | 'simple';
};

export default function CasRHFLexicalRichTextEditor({
  name,
  label,
  helperText,
  placeholder,
  mode,
}: Props) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      defaultValue=""
      render={({ field, fieldState: { error } }) => (
        <FormControl className="rhf-editor-wrapper" fullWidth error={!!error}>
          <CasSimpleLexicalRichTextEditor
            label={label}
            placeholder={placeholder}
            isError={!!error}
            initialValue={field.value}
            onChange={field.onChange}
            mode={mode}
          />
          {(!!error || helperText) && (
            <FormHelperText error={!!error}>{error ? error.message : helperText}</FormHelperText>
          )}
        </FormControl>
      )}
    />
  );
}
